import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";
import Select from "react-select";
import Crop from "../../shared/crop";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const Add = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [loading, setLoading] = useState(false);
  const [sizeDrp, setSizeDrpData] = useState([]);
  const [seriesDrp, setSeriesDrpData] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    size_id: "",
    series_id: "",
    weight: "",
    pcs_per_box: "",
    cover_area: "",
    thickness: "",
    punch: "",
    image: "",
    image_url: "",
    photo: "",
    photo_url: "",
  });

  const getSizeData = () => {
    axios.post(API_URL.SIZE_LIST, {}).then((res) => {
      setSizeDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSizeDrpData(cd);
    });
  };

  const getSeriesData = () => {
    axios.post(API_URL.SERIES_LIST, {}).then((res) => {
      setSeriesDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSeriesDrpData(cd);
    });
  };

  const onSave = () => {
    if (
      formData.name &&
      formData.size_id &&
      formData.series_id &&
      (id ? true : formData.image) 
    ) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.PRODUCT_UPDATE : API_URL.PRODUCT_SAVE;
      axios
        .post(pUrl, formData)
        .then((res) => {
          if (res.data.status === 1) {
            let message = id
              ? "Product Updated Successfully."
              : "Product Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/admin/product");
          }
        }).finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.PRODUCT_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          weight: res.data.data.weight ? res.data.data.weight : "",
          pcs_per_box: res.data.data.pcs_per_box
            ? res.data.data.pcs_per_box
            : "",
          cover_area: res.data.data.cover_area ? res.data.data.cover_area : "",
          thickness: res.data.data.thickness ? res.data.data.thickness : "",
          punch: res.data.data.punch ? res.data.data.punch : "",

          size_id: res.data.data.size_id ? res.data.data.size_id : "",
          series_id: res.data.data.series_id ? res.data.data.series_id : "",
          photo_url: res.data.data.photo ? res.data.data.photo : "",
          image_url: res.data.data.image ? res.data.data.image : "",
        });
        setImagePreview(res.data.data.image ? res.data.data.image : "");
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formData[key];
  };

  useEffect(() => {
    getSizeData();
    getSeriesData();
  }, []);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Update" : "Add"} Product</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="form-group">
                  <label>
                    Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={30}
                    value={formData.name}
                    className={
                      isRequiredField("name")
                        ? "form-control required"
                        : "form-control"
                    }
                    onChange={(event) => {
                      setFormData({ ...formData, name: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="form-group">
                  <label htmlFor="Size">
                    Size<span className="required-star">*</span>
                  </label>
                  <Select
                    options={sizeDrp}
                    value={sizeDrp.find((r) => r.value == formData.size_id)}
                    isClearable={true}
                    styles={
                      isRequiredField("size_id")
                        ? customRequireStyles
                        : customStyles
                    }
                    placeholder=""
                    onChange={(e) =>
                      setFormData({ ...formData, size_id: e.value })
                    }
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="form-group">
                  <label htmlFor="Series">
                    Series<span className="required-star">*</span>
                  </label>
                  <Select
                    options={seriesDrp}
                    value={seriesDrp.find((r) => r.value == formData.series_id)}
                    isClearable={true}
                    styles={
                      isRequiredField("series_id")
                        ? customRequireStyles
                        : customStyles
                    }
                    placeholder=""
                    onChange={(e) =>
                      setFormData({ ...formData, series_id: e.value })
                    }
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="form-group">
                  <label>Weight</label>
                  <input
                    type="text"
                    maxLength={30}
                    value={formData.weight}
                    className="form-control"
                    id="weight"
                    onChange={(event) => {
                      setFormData({ ...formData, weight: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="form-group">
                  <label>Thickness</label>
                  <input
                    type="text"
                    maxLength={30}
                    value={formData.thickness}
                    className="form-control"
                    id="thickness"
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        thickness: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="form-group">
                  <label>Cover Area</label>
                  <input
                    type="text"
                    maxLength={30}
                    value={formData.cover_area}
                    className="form-control"
                    id="cover_area"
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        cover_area: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="form-group">
                  <label>Pcs Per Box</label>
                  <input
                    type="text"
                    maxLength={30}
                    value={formData.pcs_per_box}
                    className="form-control"
                    id="pcs_per_box"
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        pcs_per_box: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="form-group">
                  <label>Punch</label>
                  <input
                    type="text"
                    maxLength={30}
                    value={formData.punch}
                    className="form-control"
                    id="punch"
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        punch: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Image<span className="required-star">*</span>
                      </label>
                      <div
                        className={isRequiredField("image") && "required-box"}
                      >
                        <Crop
                          imagePreview={imagePreview}
                          cropShape={"round"}
                          guid={""}
                          onChangeCropper={async ({
                            fileCropped,
                            fileCroppedBase64,
                          }) => {
                            setFormData({
                              ...formData,
                              image: fileCroppedBase64,
                            });
                            setImagePreview(fileCroppedBase64);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                <div className="text-end">
                  <Link
                    to={"/admin/product"}
                    className={
                      loading
                        ? "btn btn-danger btn-sm me-2 disabled-link"
                        : "btn btn-danger btn-sm me-2"
                    }
                    onClick={(e) => loading && e.preventDefault()}
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    onClick={onSave}
                    disabled={loading}
                    className="btn btn-primary btn-sm"
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {loading && (
                        <Watch color={"white"} height={15} width={15} />
                      )}
                      Submit
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Add;
